export default __webpack_public_path__ + "static/media/fasteners-manufacturing.017d45b0.png";